import { ReactNode } from 'react';

const ModuleView = ({ children }: { children: ReactNode }) => {
  return (
      <>
        <div id="moduleView">
          {children}
          </div>
      </>
  );
};  

export default ModuleView;
